import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {AnalyticsDefinition} from '../../models/vte';
import {AuthService} from '../../services/auth.service';
import {VteApiService} from '../../services/vte/vte-api.service';
import {
    customerAnalyticsDescription,
    customerAnalyticsName,
    implementationProviderLabel
} from '../../services/vte/vision-customer-labels';

@Component({
    selector: 'app-analytics-definitions-list',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './analytics-definitions-list.component.html',
    styleUrl: './analytics-definitions-list.component.css',
})
export class AnalyticsDefinitionsListComponent implements OnInit {
    loading = false;
    errorMessage = '';
    definitions: AnalyticsDefinition[] = [];

    constructor(
        private vteApi: VteApiService,
        private auth: AuthService,
    ) {
    }

    get showImplementationDetails(): boolean {
        return this.auth.isSuperUser();
    }

    get displayDefinitions(): AnalyticsDefinition[] {
        // Show Legacy and Eagle Eye V3 as distinct, mutually exclusive provider options.
        return this.definitions;
    }

    customerAnalyticsName = customerAnalyticsName;
    customerAnalyticsDescription = customerAnalyticsDescription;
    implementationProviderLabel = implementationProviderLabel;

    ngOnInit(): void {
        this.loadDefinitions();
    }

    loadDefinitions(): void {
        this.loading = true;
        this.errorMessage = '';
        this.vteApi.listAnalyticsDefinitions().subscribe({
            next: (definitions) => {
                this.definitions = definitions || [];
                this.loading = false;
            },
            error: () => {
                this.loading = false;
                this.errorMessage = 'Unable to load analytics definitions.';
                this.definitions = [];
            },
        });
    }
}
